module.exports = __webpack_public_path__ + "static/media/virginia_alexe.79ea74a1.jpg";